import React, { Component } from 'react';

import config from '../../../config';
import { Loading } from '../../components/shared';

const ClearanceLoading = () => (
    <div className="container">
        <div className="row">
            <div className="col-xs-12">
                <h1>Checking Prior Submissions</h1>
                <p className="text">Please Wait while we scan for matches.</p>
                <div className="loadingImg">
                    <Loading width="200px" height="200px" />
                </div>
            </div>
        </div>
    </div>
);

export default ClearanceLoading;
